<template>
  <div class="scroll-y custom-scrollbar">
    <ion-row>
      <ion-col size="12" size-xl="10" offset-xl="1">
        <div class="padding">

          <h1 class="h3">Raport zadań specjalnych</h1>
          <p v-show="!this.loaded" class="text-center smaller">Poczekaj na dane</p>
          <div v-if="loaded" class="box">
            <form class="form form-generate-report">
              <p class="text-bold">Zakres raportu</p>
              <ion-row>
                <ion-col size="12" size-md="4">
                  <div class="form-group mb-0">
                    <label>Miesiąc:</label>
                    <div class="select-wrapper">
                      <span v-if="form.month === ''" class="select-placeholder">Wybierz miesiąc</span>
                      <select v-model="form.month" @change="getReports">
                        <option v-for="(item,key) in monthCollection" :key="key" :value="parseInt(key)+1">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="4">
                  <div class="form-group mb-0">
                    <label>Kwartał:</label>
                    <div class="select-wrapper">
                      <span v-if="form.quarter === ''" class="select-placeholder">Wybierz kwartał</span>
                      <select v-model="form.quarter" @change="getReports">
                        <option v-for="(item,key) in quarterCollection" :key="key" :value="parseInt(key)+1">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="4">
                  <div class="form-group mb-0">
                    <label>Rok:</label>
                    <div class="select-wrapper">
                      <span v-if="form.year === ''" class="select-placeholder">Wybierz rok</span>
                      <select v-model="form.year" @change="getReports">
                        <option v-for="(item,key) in yearCollection" :key="key" :value="item">{{ item }}</option>
                      </select>
                    </div>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="4" v-if="userTypeCollection">
                  <div class="form-group mb-0">
                    <label>Typ uczestnika:</label>
                    <div class="select-wrapper">
                      <span v-if="form.user_type === ''" class="select-placeholder">Wybierz typ uczestnika</span>
                      <select v-model="form.user_type" @change="getReports">
                        <option v-for="(item,key) in userTypeCollection" :key="key" :value="item.id">{{ item.value }}</option>
                      </select>
                    </div>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="8" v-if="specialTypeCollection">
                  <div class="form-group mb-0">
                    <label>Zadanie specjalne:</label>
                    <div class="select-wrapper">
                      <span v-if="form.special_type === ''" class="select-placeholder">Wybierz zadanie specjalne</span>
                      <select v-model="form.special_type" @change="getReports">
                        <option v-for="(item,key) in specialTypeCollection" :key="key" :value="item.id">{{ item.value }}</option>
                      </select>
                    </div>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="4" v-if="rsmCollection">
                  <div class="form-group mb-0">
                    <label>Regionalny Manager Sprzedaży:</label>
                    <div class="select-wrapper">
                      <span v-if="form.rsm === ''" class="select-placeholder">Wybierz RSM</span>
                      <select v-model="form.rsm" @change="getReports">
                        <option v-for="(item,key) in rsmCollection" :key="key" :value="item.id">{{ item.full_name }}</option>
                      </select>
                    </div>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="4" v-if="sellersCollection">
                  <div class="form-group mb-0">
                    <label>Przedstawiciel handlowy:</label>
                    <div class="select-wrapper">
                      <span v-if="form.sellers === ''" class="select-placeholder">Wybierz PH</span>
                      <select v-model="form.sellers" @change="getReports">
                        <option v-for="(item,key) in sellersCollection" :key="key" :value="item.id">{{ item.full_name }}</option>
                      </select>
                    </div>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="8">
                  <div class="form-group">
                    <label>Wyszukaj:</label>
                    <input v-model="form.search" @input="searchTimeOut" type="text"
                           placeholder="Wpisz Nazwę uczestnika lub Numer odbiorcy lub Nazwę odbiorcy"/>
                  </div>
                </ion-col>
                <ion-col size="12" size-md="4" v-if="showButtonClearFilters">
                  <div class="text-right mb-10" style="margin-top: 18px">
                    <button class="btn btn-block btn-gray inline-block m-0" @click="clearFilters($event)">
                      <span>Wyczyść filtry</span>
                    </button>
                  </div>
                </ion-col>
              </ion-row>
            </form>
          </div>

          <h2 class="h3 text-up">Wyniki</h2>

          <div v-if="loadingButton" class="loader-wrapper smaller inline-block" style="min-height: 28px">
            <span class="loader red"></span>
          </div>
          <div v-else>
            <span class="link nowrap" v-if="summaryReportUri" @click="saveFile(summaryReportUri, 'raport-pełen.xlsx')">
              <svg><use xlink:href="#icon-details"></use></svg>
              <span>Pobierz pełen raport</span>
            </span>
          </div>

          <server-table ref="reportsTable" :url="'/api/v1/specials/report'" :params="form"></server-table>

        </div>
      </ion-col>
    </ion-row>
  </div>
</template>

<script>
  import api from '@/services/Api';
  // import FileSaver from 'file-saver';
  import ServerTable from "../../components/ServerTable.vue";
  import Save from "@/services/Save";

  function getDefaultFormData() {
    return {
      month: '',
      quarter: '',
      year: '',
      user_type: '',
      special_type: '',
      rsm: '',
      sellers: '',
      search: ''
    }
  }

  export default {
    name: 'ReportKnowledgeIndex',
    components: {ServerTable},
    data() {
      return {
        loaded: false,
        loadingButton: false,

        monthCollection: [],
        quarterCollection: [],
        yearCollection: [],
        //
        userTypeCollection: [],
        specialTypeCollection: [],
        rsmCollection: [],
        sellersCollection: [],
        //
        summaryReportUri: null,
        form: getDefaultFormData()
      }
    },
    computed: {
      showButtonClearFilters() {
        if (this.form.month === ''
         && this.form.quarter === ''
         && this.form.year === ''
         && this.form.user_type === ''
         && this.form.special_type === ''
         && this.form.rsm === ''
         && this.form.sellers === ''
         && this.form.search === '') {
          return false
        } else {
          return true
        }
      }
    },
    methods: {
      getReports() {
        this.$refs.reportsTable.getData();
      },
      searchTimeOut() {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.getReports();
        }, 500);
      },
      clearFilters(event) {
        event.preventDefault();
        this.form = getDefaultFormData();
        setTimeout(() => {
          this.getReports();
        }, 50);
      },
      saveFile(uri, name) {
        this.loadingButton = true;
        api.get(uri).then(response => {
          // FileSaver.saveAs(response.data, name);
          Save.file(response, name, {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"})
          this.loadingButton = false;
        }).catch(err => {
          this.loadingButton = false;
          let error = err.message ? err.message : '';
          this.$ionic.alertController
            .create({
              header: 'Błąd!',
              message: 'Nie udało się pobrać pliku.<br/>' + error,
              buttons: ['OK'],
              mode: 'md'
            })
            .then(a => a.present());
        })
      }
    },
    mounted () {
      setTimeout(() => { this.loaded = true }, 1500)
    }
  }
</script>
